import { render } from "./Main.vue?vue&type=template&id=26d91d5c&scoped=true"
import script from "./Main.vue?vue&type=script&lang=js"
export * from "./Main.vue?vue&type=script&lang=js"

import "./Main.vue?vue&type=style&index=0&id=26d91d5c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-26d91d5c"

export default script